import { TransactionAttributeDto } from './transaction-attribute.dto';

export class TransactionSpecDto {
  id: string;
  name: string;
  transactionAttributes: TransactionAttributeDto[] = [];

  constructor(d?: TransactionSpecDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.name = d.name;
    if (d.transactionAttributes) {
      this.transactionAttributes = d.transactionAttributes.map(
        t => new TransactionAttributeDto(t)
      );
    }
  }
}
